// extracted by mini-css-extract-plugin
module.exports = {"flex":"Flex_flex__OPG3I","desktop":"Flex_desktop__CTCl_"};